export const calculateProductPricing = ({
  total_cost,
  monthly_payment,
  surchargesValues,
  discount,
  coverage_months,
  monthly_membership = false,
}) => {
  // Parse base costs with fallbacks
  let calcTotal = parseFloat(total_cost) || 0
  let calcMonthly = parseFloat(monthly_payment) || 0

  // Apply discount ONLY to base costs (not to surcharges).
  //
  // A monthly membership is priced by its configured margin tier and carries no
  // free-form discount at all -- ProductPackages::Update clears one left over
  // from a fixed-term plan the agent had selected first. Skipping every
  // reduction here keeps the card showing what the server will charge; reducing
  // only the monthly, as this did before, showed a discounted total against an
  // undiscounted monthly.
  if (
    !monthly_membership &&
    discount &&
    typeof discount.amount === 'number' &&
    discount.amount > 0
  ) {
    const { amount, type } = discount

    // Calculate reductions with validation
    const totalReduction = type === '%' ? (calcTotal * amount) / 100 : amount
    const monthlyReduction =
      type === '%'
        ? (calcMonthly * amount) / 100
        : coverage_months > 0
        ? amount / coverage_months
        : 0

    // Apply reductions but don't allow negative totals
    calcTotal = Math.max(0, calcTotal - totalReduction)
    calcMonthly = Math.max(0, calcMonthly - monthlyReduction)
  }

  // Add surcharges AFTER discount (surcharges are never discounted)
  // Validate surchargesValues exists and has valid numbers
  const surchargeTotal = Number(surchargesValues?.costTotal) || 0
  const surchargeMonthly = Number(surchargesValues?.monthlyTotal) || 0

  calcTotal += surchargeTotal
  calcMonthly += surchargeMonthly

  return {
    totalCost: calcTotal,
    monthlyCost: calcMonthly,
  }
}
